import axios from 'axios';
import store from '../redux/store/store';
import { set_user } from '../redux/reducer/user';
import {
  getVerificationRedirectPath,
  isVerificationRequiredError,
  persistVerificationUser,
} from '../utils/verificationGate';
import { getActiveAccountId } from '../utils/accountContext';

axios.defaults.headers = 'application/json';
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const activeAccountId = getActiveAccountId();
  if (activeAccountId) {
    config.headers = config.headers || {};
    config.headers['X-Act-As-User'] = activeAccountId;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isVerificationRequiredError(error) && typeof window !== 'undefined') {
      const payload = error.response.data;
      const path = getVerificationRedirectPath(payload);
      if (!window.location.pathname.startsWith('/verify/')) {
        persistVerificationUser(payload.user);
        store.dispatch(set_user(payload.user));
        window.location.assign(path);
      }
    }
    return Promise.reject(error);
  },
);

export * from './auth';
export * from './common';
export * from './user';